import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IpopConfiguration } from '../../../../../model/ipop-configuration.model';

@Component({
  selector: 'auto-vdp-offers',
  templateUrl: './vdp-offers.component.html',
  styleUrls: ['./vdp-offers.component.scss'],
  standalone: false
})
export class VdpOffersComponent implements OnInit, OnChanges {
  @Input() isReadOnly = true;
  @Input() data: IpopConfiguration | null = null;
  @Output() formGroupInitialized = new EventEmitter<UntypedFormGroup>();

  form: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder) {
  }

  /** Initializes controls and applies the account lock before exposing the form. */
  ngOnInit(): void
  {
    this.form = this.formBuilder.group({
      vdpOfferWidgetEnabled:  [false, Validators.required],
      offerTextColor:         ['#000000', Validators.required],
      ctaTextFontSize:        [22, Validators.required],
      clickToCallTextFontSize:[22, Validators.required],
      ctaButtonColor:         ['#000000', Validators.required],
      clickToCallEnabled:     [true, Validators.required],
      clickToCallText:        ['[DealerPhone]', Validators.required],
      clickToCallBackgroundColor: ['#000000', Validators.required],
      clickToCallTextColor:   ['#ffffff', Validators.required],
      showCtaWithoutOffers:   [false, Validators.required],
    });
    this.applySettings();
    this.updateDisabledState();
    this.formGroupInitialized.emit(this.form);
  }

  /** Applies saved responses without overwriting edits when only the lock changes. */
  ngOnChanges(changes: SimpleChanges): void
  {
    if (changes.data) {
      this.applySettings();
    }
    this.updateDisabledState();
  }

  /** Displays saved values even when the tab mounts after its data has loaded. */
  private applySettings(): void
  {
    const hasIncoming = !!this.data && !!this.form;
    if (hasIncoming) {
      this.form.patchValue({
        vdpOfferWidgetEnabled: !!this.data.vdpOfferWidgetEnabled,
        offerTextColor:        this.data.offerTextColor || '#000000',
        ctaTextFontSize:       this.data.ctaTextFontSize || 22,
        clickToCallTextFontSize: this.data.clickToCallTextFontSize || 22,
        ctaButtonColor:        this.data.ctaButtonColor || '#000000',
        clickToCallEnabled:    this.data.clickToCallEnabled,
        clickToCallText:       this.data.clickToCallText,
        clickToCallBackgroundColor: this.data.clickToCallBackgroundColor,
        clickToCallTextColor:  this.data.clickToCallTextColor,
        showCtaWithoutOffers:  !!this.data.showCtaWithoutOffers,
      }, { emitEvent: false });
      this.form.markAsPristine();
    }
  }

  /** Changes only control availability, preserving all saved and unsaved values. */
  private updateDisabledState(): void
  {
    if (this.form) {
      if (this.isReadOnly || this.data === null) {
        this.form.disable({emitEvent: false});
      } else {
        this.form.enable({emitEvent: false});
      }
    }
  }

  /** Guards native color inputs, which do not inherit the reactive form lock. */
  setColor(controlName: string, event: Event): void
  {
    const control = this.form?.get(controlName);
    if (!this.isReadOnly && control?.enabled && event.target instanceof HTMLInputElement) {
      control.setValue(event.target.value);
      control.markAsDirty();
    }
  }
}
